import styled from 'styled-components';

export const Print = styled.button`
  height: 48px;
  width: 440px;
  border-radius: 5px;
  border: none;
  background: #ff2c3a;
  font-weight: bold;

  svg {
    margin-right: 6px;
  }

  :hover {
    filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.2));
  }
`;

export const PrintNoBorder = styled.button`
  height: 48px;
  width: 440px;
  border-radius: 5px;
  border: none;
  background: transparent;
  color: #ff2c3a;
  font-weight: bold;
  text-decoration: underline;
  margin-bottom: 20px;

  svg {
    margin-right: 6px;
  }

  :hover {
    filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.2));
  }
`;

export const PrintOutline = styled.button`
  height: 48px;
  width: 440px;
  border-radius: 5px;
  border: 1px solid #ff2c3a; 
  background: transparent;
  color: #ff2c3a;
  font-weight: bold;
  text-decoration: none; 
  margin-bottom: 20px;

  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    margin-right: 6px;
  }

  :hover {
    background: rgba(255, 44, 58, 0.05);
    filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.2));
  }

  :disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;